/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import Grid from "@mui/material/Grid";
import EmailCheck from "../../EmailCheck/EmailCheck";
import ButtonLoading from "../../Button/ButtonLoading";
import ButtonTextTermsOfServicePrivacy from "../Common/ButtonTextTermsOfServicePrivacy/ButtonTextTermsOfServicePrivacy";
import React from "react";
import { useForm } from "../../../provider/Form/FormProvider";
import civilLawCheckinStyle from "./civilLawCheckinStyle";
import { emailDefault, requiredValidator } from "../../../services/validationRules";
import { translate } from "../../../services/translations/translations";
import ValidatorMultiSelectFieldWithCheckboxes from "../../FormFields/ValidatorMultiSelectFieldWithCheckboxes";

type CivilLawCheckinFormProps = {
  emailErrorText: string;
  setEmailErrorText: (emailErrorText: string) => void;
  isLoading: boolean;
};

export default function CivilLawCheckinForm({ emailErrorText, setEmailErrorText, isLoading }: CivilLawCheckinFormProps) {
  const { handleSubmit } = useForm();
  return (
    <form onSubmit={handleSubmit}>
      <Grid
        container
        sx={{
          alignItems: "flex-start",
          justifyContent: "center"
        }}>
        <Grid
          sx={civilLawCheckinStyle.gridSpaceMd}
          size={{
            xs: 12,
            md: 4
          }}>
          <ValidatorMultiSelectFieldWithCheckboxes
            label="Ihr Anliegen"
            name={`objectivesClient`}
            validators={[requiredValidator("Bitte geben Sie die Art Ihres Anliegens an.")]}
            options={[
              { value: "payment", label: translate("generalCivilLaw.objectivesClient.options.payment.label", {}) },
              {
                value: "injunction",
                label: translate("generalCivilLaw.objectivesClient.options.injunction.label", {}),
              },
              { value: "removal", label: translate("generalCivilLaw.objectivesClient.options.removal.label", {}) },
              { value: "handover", label: translate("generalCivilLaw.objectivesClient.options.handover.label", {}) },
              { value: "other", label: translate("generalCivilLaw.objectivesClient.options.other.label", {}) },
            ]}
          />
        </Grid>
        <Grid
          sx={civilLawCheckinStyle.gridSpace}
          size={{
            xs: 12,
            sm: 4
          }}>
          <EmailCheck
            name="email"
            label="Ihre E-Mail-Adresse"
            autoComplete="email"
            emailErrorText={emailErrorText}
            setEmailErrorText={setEmailErrorText}
            validators={[requiredValidator("Bitte geben Sie Ihre E-Mail-Adresse an"), emailDefault]}
          />
        </Grid>
        <Grid
          sx={[civilLawCheckinStyle.submit, civilLawCheckinStyle.gridTopSpaced]}
          size={{
            xs: 12,
            sm: 4
          }}>
          <ButtonLoading variant="contained" color="primary" sx={civilLawCheckinStyle.button} type="submit" fullWidth isLoading={isLoading}>
            jetzt starten
          </ButtonLoading>
          <ButtonTextTermsOfServicePrivacy />
        </Grid>
      </Grid>
    </form>
  );
}
